var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 704.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e7e4e0;\n      }\n\n      .cls-2 {\n        fill: #0796a6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.76,396.93c3.18-7.12,6.6-14.29,10.27-21.47,10.24-15.71,23.86-24.75,37.31-22.74,11.79,1.79,21.19,11.74,26.76,26.3,1.28,5.79,2.77,11.44,4.43,16.93,12.09,40.05,34.02,72.28,65.95,92.79,107.96,69.42,290.28-20.76,412.01-201.81,2.72-3.99,5.38-8.04,8.02-12.15,0-.05.03-.08.08-.11,17.83-23.69,41.55-35.51,58.58-27.17,18.23,8.97,22.85,38.2,12.44,69.18-.68,2.01-1.39,3.99-2.2,5.98-28.86,76.73-85.62,158.01-164.99,227.84-168.82,148.52-375.93,189.06-462.58,90.56-50.27-57.12-48.99-148.5-6.09-244.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.24,307.46c-3.18,7.12-6.6,14.29-10.27,21.47-10.24,15.71-23.86,24.75-37.31,22.74-11.79-1.79-21.19-11.74-26.76-26.3-1.28-5.79-2.77-11.44-4.43-16.93-12.09-40.05-34.02-72.28-65.95-92.79-107.96-69.42-290.28,20.76-412.01,201.81-2.72,3.99-5.38,8.04-8.02,12.15,0,.05-.03.08-.08.11-17.83,23.69-41.55,35.51-58.58,27.17-18.23-8.97-22.85-38.2-12.44-69.18.68-2.01,1.39-3.99,2.2-5.98,28.86-76.73,85.62-158.01,164.99-227.84C359.4,5.36,566.51-35.18,653.16,63.32c50.27,57.12,48.99,148.5,6.09,244.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeLogo);
export default __webpack_public_path__ + "static/media/ce-logo.a3d10b133f1f0b9b8e127708921c5bfa.svg";
export { ForwardRef as ReactComponent };